import { render } from "./AddTeacherModal.vue?vue&type=template&id=7d633c68&scoped=true"
import script from "./AddTeacherModal.vue?vue&type=script&lang=js"
export * from "./AddTeacherModal.vue?vue&type=script&lang=js"

import "./AddTeacherModal.vue?vue&type=style&index=0&id=7d633c68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d633c68"]])

export default __exports__